import { StaffPositionEnum } from '../../types/enums/staff/staff-position.enum'
import { StaffQualificationEnum } from '../../types/enums/staff/staff-qualifications.enum'
import { PayScaleTypeEnum } from '../../types/enums/staff-pay-scale/pay-scale-type.enum'
import { StaffPayScaleFilters } from '../../types/models/staff-pay-scale/staff-pay-cale'

export const transformStaffPayScaleFiltersToUrl = (filters?: StaffPayScaleFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.countries && filters.countries.length)
    searchParams.append('countries', filters.countries.join(','))

  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))
  if (filters.formulas && filters.formulas.length)
    searchParams.append('formulas', filters.formulas.join(','))
  if (filters.position) searchParams.append('position', filters.position.toString())
  if (filters.type) searchParams.append('type', filters.type.toString())
  if (filters.qualifications && filters.qualifications.length)
    searchParams.append('qualifications', filters.qualifications.join(','))

  return searchParams.toString()
}

export const transformUrlToStaffPayScaleFilters = (
  searchParams: URLSearchParams
): StaffPayScaleFilters => {
  const filters: StaffPayScaleFilters = {}

  const countries = searchParams.get('countries')
  if (countries && countries.length) filters.countries = countries.split(',')

  const periods = searchParams.get('periods')
  if (periods && periods.length) filters.periods = periods.split(',')

  const formulas = searchParams.get('formulas')
  if (formulas && formulas.length)
    filters.formulas = formulas.split(',').map((formula) => parseInt(formula))

  const position = searchParams.get('position')
  if (position) filters.position = position as StaffPositionEnum

  const type = searchParams.get('type')
  if (type) filters.type = type as PayScaleTypeEnum

  const qualifications = searchParams.get('qualifications')
  if (qualifications && qualifications.length)
    filters.qualifications = qualifications.split(',') as StaffQualificationEnum[]

  return filters
}
